<template>
	<div class='route_container'>
	</div>
</template>

<script>
	import AjaxErrorHandler from '../../assets/js/errorHandler'
	
	export default {
		name: 'P',
		methods: {
			redirect () {

				let id = this.$route.params.id
				let gameseo = this.$route.params.gameseo

				this.axios
					.get('/api/v1/post/' + id)
					.then((res) => {
						// let gameseo = this.$store.state.meta.gamesDict[res.data.GameId];
						if(res.data.Thread.lang === this.$store.state.meta.lang){
							this.$router.push(
								`/${this.$store.state.meta.lang}/game/${gameseo}/thread/${res.data.Thread.slug}/${res.data.Thread.id}/${res.data.postNumber}`
							)
						}
					})
					.catch(AjaxErrorHandler(this.$store))
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => vm.redirect())
		}
	}
</script>